module.exports = __webpack_public_path__ + "img/construction.a42757ee.png";